export enum EkranDecyzjiActionType {
    KLIKNIETO_ZAAKCEPTUJ = '[Ekran decyzji] Kliknieto zaakceptuj',
    KLIKNIETO_ZAAKCEPTUJ_SUCCESS = '[Ekran decyzji] Zaakceptowano samoobsluge'
}
